export default "__VITE_ASSET__C2L4wtOM__"